import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput } from '../../Form';
import ReactDropzone from 'react-dropzone';
import ColumnSelect from './ColumnSelect';

@inject('reportingTemplateStore', 'reportingTemplateHeaderStore', 'rolePermissionStore')
@observer
class ReportingTemplateModify extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable editMode = false;

  @observable item = {
    name: '',
    description: '',
    format: '',
    orientation: '',
    header_id: null,
    sort_order: null,
    sort_by: null
  };
  @observable columns = [];
  @observable addColumn = false;
  @observable editColumn = null;
  @observable exchangeColumn = null;

  slug = '/export/report/template';
  resource = 'data-delivery';
  title = '';

  componentWillMount() {
    const { params: { id } } = this.props;

    this.editMode = id !== 'add';
    if (this.editMode) {
      this.title = 'Edit Reporting Template';
      this.reset();
    } else this.title = 'Add Reporting Template ';
  }

  @action onChange = (e, field) => this.item[field] = e.target.value;

  onAddColumn = col => this.columns.push(col);
  onRemoveColumn = i => this.columns.splice(i, 1);
  onUpdateColumn = col => this.columns[this.editColumn] = col;
  onExchangeColumn = i => {
    if (!this.exchangeColumn && this.exchangeColumn !== 0) {
      this.exchangeColumn = i;
    } else if (this.exchangeColumn === i) {
      this.exchangeColumn = null;
    } else {
      let temp = this.columns[i];
      this.columns[i] = this.columns[this.exchangeColumn];
      this.columns[this.exchangeColumn] = temp;
      this.exchangeColumn = null;
    }
  }

  @action reset = (counter = 0) => {
    const { params: { id }, reportingTemplateStore } = this.props;
    const foundUnit = reportingTemplateStore.findById(id);
    if (foundUnit) {
      let item = Object.assign({}, foundUnit.asJson);
      let columns = (item.columns && item.columns.length) ? item.columns : [];
      delete item.columns;
      this.item = item;
      this.columns = columns;
    } else if (counter < 5) {
      setTimeout(() => {
        this.reset(counter + 1);
      }, 500)
    }
  }

  @action onChange = (e, field) => this.item[field] = e.target.value;
  @action onChangeSortBy = (e, field) => {
    let value = e.target.value !== '' ? e.target.value : null;
    this.item[field] = value;
  };


  handleSave = (e) => {
    e.preventDefault();

    const { reportingTemplateStore } = this.props;
    const { notify, router } = this.context;
    (this.editMode ? reportingTemplateStore.updateItem(Object.assign({}, toJS(this.item), { columns: toJS(this.columns).map((item, i) => Object.assign(item, { seq: i + 1 })) })) : reportingTemplateStore.createItem(Object.assign({}, toJS(this.item), { columns: toJS(this.columns).map((item, i) => Object.assign(item, { seq: i + 1 })) })))
      .then(() => {
        notify.success({ message: 'Success' });
        reportingTemplateStore.fetchItems();
        router.push(this.slug);
      })
      .catch(err => {
        console.log(err);
        notify.error(err);
      });
  }

  onUpload = (files) => {
    const { notify } = this.context;

    let reader = new FileReader();
    reader.readAsText(files[0]);
    reader.onabort = console.log;
    reader.onload = () => {
      try {
        let payload = JSON.parse(reader.result);
        this.item = {
          name: payload.name,
          description: payload.description,
          format: payload.format,
          orientation: payload.orientation,
          header_id: payload.header_id || null,
        };
        this.columns = payload.columns;
      } catch (e) {
        console.log(e)
        notify.error({ message: 'Invalid File.' })
      }
    }
  }

  onDownload = (e) => {
    e.preventDefault();
    let payload = {
      name: this.item.name,
      description: this.item.description,
      format: this.item.format,
      orientation: this.item.orientation,
      header_id: this.item.header_id,
      columns: this.columns,
    };
    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    hiddenElement.href = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(payload));
    hiddenElement.target = '_blank';
    hiddenElement.download = `Report_Template-${payload.name.split(' ').join('_')}-${Date.now()}.json`;
    hiddenElement.click();
  };

  render() {
    const { reportingTemplateStore, reportingTemplateHeaderStore, rolePermissionStore } = this.props;
    const canModify = rolePermissionStore.validateRole(`modify ${this.resource}`);
    const header = this.item.header_id ? reportingTemplateHeaderStore.findById(this.item.header_id) : null;

    let sortByData = this.columns && this.columns.map((item) => {
      return { label: item.label, value: item.label }
    })

    return (
      <Modal title={this.title} slug={this.slug} isSaving={reportingTemplateStore.isSaving} handleSave={canModify ? this.handleSave : null} isLoading={reportingTemplateStore.isLoading || reportingTemplateHeaderStore.isLoading}>
        <Form>
          <div className='flex'>
            <FormBody>
              <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChange(e, 'name')} readOnly={!canModify} />
              <TextInput label={'Description'} value={this.item.description} onChange={e => this.onChange(e, 'description')} readOnly={!canModify} />
              <SelectInput readOnly={!canModify} label='Format' value={this.item.format} onChange={e => this.onChange(e, 'format')} options={reportingTemplateStore.formatOptions} fields={{ label: 'label', value: 'value' }} />
              {this.item.format === 'pdf' &&
                <div>
                  <SelectInput readOnly={!canModify} label='Orientation' value={this.item.orientation} onChange={e => this.onChange(e, 'orientation')} options={reportingTemplateStore.orientationOptions} fields={{ label: 'label', value: 'value' }} />
                  <SelectInput readOnly={!canModify} label='Header' value={this.item.header_id} onChange={e => this.onChange(e, 'header_id')} options={reportingTemplateHeaderStore.items.map(item => ({ label: item.title1, value: item.id }))} fields={{ label: 'label', value: 'value' }} />
                </div>
              }
              <SelectInput
                label={'Sort By'}
                value={this.item.sort_by}
                fields={{ label: 'label', value: 'value' }}
                options={sortByData}
                onChange={e => this.onChangeSortBy(e, 'sort_by')}
              />
              <SelectInput
                label={'Sort Order'}
                value={this.item.sort_order}
                fields={{ label: 'label', value: 'value' }}
                options={reportingTemplateStore.sortOrder}
                onChange={e => this.onChangeSortBy(e, 'sort_order')}
              />
            </FormBody>
          </div>
          {header && <div className='flex flex-row space-between bordered' style={{ margin: '20px 0', padding: '10px' }}>
            <img src={header.logo} style={{ width: '80px', height: '80px' }} alt='not-found' />
            <div className='flex flex-column justify-center v-center' style={{ margin: '0 20px' }}>
              <span>{header.title1}</span>
              <span style={{ height: '8px' }} />
              <span>{header.title2}</span>
              <span style={{ height: '8px' }} />
              <span style={{ fontSize: 12 }}>{this.item.description}</span>
            </div>
            <div></div>
          </div>}
          <div className='report-template-columns'>
            {this.columns.map((item, i) => {
              return <div key={`template-column-${i}`} className={`report-template-column ${this.exchangeColumn === i ? 'report-template-column-highlight' : ''}`}>
                {canModify && <i className='fa fa-close report-column-remove' onClick={() => this.onRemoveColumn(i)} />}
                <div onDoubleClick={() => this.editColumn = canModify ? i : null} className='report-template-column-label'>{item.label}</div>
                {canModify && <div className='flex flex-row space-between'>
                  {i > 0 ? <i className='fa fa-caret-left report-column-move-left' onClick={() => { this.onExchangeColumn(i); this.onExchangeColumn(i - 1) }} /> : <i />}
                  <i className='fa fa-exchange report-column-exchange' onClick={() => this.onExchangeColumn(i)} />
                  {i < this.columns.length - 1 ? <i className='fa fa-caret-right report-column-move-right' onClick={() => { this.onExchangeColumn(i); this.onExchangeColumn(i + 1) }} /> : <i />}
                </div>}
              </div>
            })}
            {canModify && <div className='report-template-column' onClick={() => this.addColumn = !this.addColumn} style={{ minWidth: '50px' }}>
              <span className='fa fa-plus white report-template-column-label' />
            </div>}
          </div>
          {canModify ? <FormActions>
            <button onClick={this.handleSave}>Save</button>
            {this.editMode ?
              <button onClick={this.onDownload}>Download</button> :
              <button onClick={e => { e.preventDefault(); this.refs.dropzone.open(); }}>Upload</button>
            }
          </FormActions> : <div style={{ height: 20 }} />}
          {this.addColumn && <ColumnSelect onAddColumn={this.onAddColumn} onClose={() => this.addColumn = false} columns={this.columns} />}
          {(this.editColumn || this.editColumn === 0) && <ColumnSelect column={this.columns[this.editColumn]} columns={this.columns} onUpdateColumn={this.onUpdateColumn} onClose={() => this.editColumn = null} />}
        </Form>
        <ReactDropzone ref="dropzone" onDrop={this.onUpload} style={{ display: 'none' }} />
      </Modal>
    );
  }
}

export default ReportingTemplateModify;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportingTemplateModify.js